

import { Version } from '@angular/core';

export const VERSION = new Version('15.1.2');
